import React, { useEffect, useState } from "react";
import { FaTwitter, FaInstagram, FaYoutube, FaWhatsapp } from "react-icons/fa";
import "../layouts/about.css";
import { siteSettings } from "../Data/axios";

function Footer() {
  const [siteData, setSiteData] = useState({}); // Initialize as an empty object
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const fetchData = async () => {
      try {
        const data = await siteSettings.getSettingsForWebsite();
        setSiteData(data || {});
      } catch (err) {
        setError(err.message || "Failed to fetch site data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    return () => {
      isMounted = false;
    };
  }, {});
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <a href="/about">About</a>
            </li>
            <li>
              <a href="/features">Features</a>
            </li>
            <li>
              <a href="/blogs">Resources</a>
            </li>
            <li>
              <a href="/plans">Plans</a>
            </li>
            <li>
              <a href="/faqs">FAQs</a>
            </li>
            <li>
              <a href="/contact-us">Contact Us</a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Our Products</h3>
          <ul>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.roadpilot">
                Road Pilot Driver (Truck)
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.owner">
                Road Pilot Owner (Truck)
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.craneowner">
                Road Pilot Crane
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.roadpilotdhaba">
                Road Pilot Dhaba
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.roadpilotmech">
                Road Pilot Mechanic
              </a>
            </li>
            <li>
              <a href="https://play.google.com/store/apps/details?id=com.rptpl.craneoperator">
                Road Pilot Crane Operator
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Services</h3>
          <ul>
            <li>
              <a href="/Login-help">Raise Tickets</a>
            </li>
            <li>
              <a href="/">Road Pilot</a>
            </li>
            <li>
              <a href="/verification">Verification</a>
            </li>
            <li>
              <a href="/careers">Careers</a>
            </li>
          </ul>
        </div>
      </div>
      <div className="blue-container">
        <div className="grid grid-cols-4 grid-rows-3 gap-0">
          <div className="row-span-2">
            <div className="logo-container">
              <img
                src="https://roadpilot.co.in/assets/images/general/logo_white.png"
                alt="Logo"
                className="footer-logo"
              />
            </div>
          </div>
          <div className="row-span-2 col-start-4">
            <div className="py-14">
              <h3 className="text-center">Contact Us</h3>
              <div className="social-icons">
                <a
                  href={siteData.site_twitter}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#1DA1F2" }}
                >
                  <FaTwitter />
                </a>
                <a
                  href={siteData.site_instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#E1306C" }}
                >
                  <FaInstagram />
                </a>
                <a
                  href={siteData.site_youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#FF0000" }}
                >
                  <FaYoutube />
                </a>
                <a
                  href={siteData.site_whatsapp}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#25D366" }}
                >
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </div>
          <div className="col-span-2 col-start-2 row-start-3">
            <div className="footer-links ">
              <a href="#">Terms and Policies</a>
              <a href="https://info.roadpilot.co.in/privacypolicy/">
                Privacy Policy
              </a>
              <a href="/verification">Verification</a>
            </div>
            <div className="text-center align-text-bottom">
              <p>&copy; 2025 RPTPL. All rights reserved.</p>
            </div>
          </div>
          {/* <div className="col-span-2 col-start-2 row-start-4">
            <div className="text-center align-text-bottom">
              <p>&copy; 2025 RPTPL. All rights reserved.</p>
            </div>
          </div> */}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
